import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "mb-2 leading-7 text-sm font-medium text-gray-500" }, "対象生徒", -1)
const _hoisted_3 = {
  key: 0,
  class: "mb-6 flex flex-wrap border-b border-gray-500"
}
const _hoisted_4 = { class: "text-sm font-medium" }
const _hoisted_5 = {
  key: 1,
  class: "flex items-center text-yellow-300"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium text-gray-500" }, " 生徒が一人も選択されていません。生徒一覧画面に戻って操作をやり直してください。 ", -1)
const _hoisted_7 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " メッセージ対象の絞り込み方法 ", -1)
const _hoisted_9 = { class: "p-4 flex justify-around bg-primary-100 rounded-md" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "group",
  class: "pl-3"
}, "グループ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "school",
  class: "pl-3"
}, "スクール", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "classroom",
  class: "pl-3"
}, "教室", -1)
const _hoisted_15 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "mt-2 w-full text-center text-gray-500 text-sm" }, " ※ グループを選択しない場合、全生徒にメッセージが送信されます ", -1)
const _hoisted_17 = {
  key: 3,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = {
  key: 0,
  class: "w-full p-2 mt-3 rounded-md bg-white shadow"
}
const _hoisted_20 = {
  key: 0,
  class: "text-secondary-500 w-16 flex justify-center"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 追加 ")
const _hoisted_22 = { class: "flex flex-col ml-2" }
const _hoisted_23 = { class: "text-sm font-medium" }
const _hoisted_24 = { class: "text-gray-500 text-xs" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "mb-2 leading-7 text-sm font-medium text-gray-500" }, " 以下のスクールの生徒に送信 ", -1)
const _hoisted_27 = { class: "mb-2 flex flex-wrap border-b border-gray-500" }
const _hoisted_28 = { class: "text-sm font-medium" }
const _hoisted_29 = { class: "flex mt-2" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 全スクールを選択 ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 全スクールの選択を解除 ")
const _hoisted_32 = {
  key: 4,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = {
  key: 0,
  class: "w-full p-2 mt-3 rounded-md bg-white shadow"
}
const _hoisted_35 = {
  key: 0,
  class: "text-secondary-500 w-16 flex justify-center"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 追加 ")
const _hoisted_37 = { class: "flex flex-col ml-2" }
const _hoisted_38 = { class: "text-sm font-medium" }
const _hoisted_39 = { class: "text-gray-500 text-xs" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "mb-2 leading-7 text-sm font-medium text-gray-500" }, " 以下の教室の生徒に送信 ", -1)
const _hoisted_42 = { class: "mb-2 flex flex-wrap border-b border-gray-500" }
const _hoisted_43 = { class: "text-sm font-medium" }
const _hoisted_44 = { class: "flex mt-2" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 全教室を選択 ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 全教室の選択を解除 ")
const _hoisted_47 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_48 = { class: "leading-7 text-sm text-gray-600" }
const _hoisted_49 = {
  key: 0,
  class: "leading-7 text-sm text-red-500"
}
const _hoisted_50 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_51 = { class: "w-full" }
const _hoisted_52 = /*#__PURE__*/_createVNode("p", { class: "mb-1 font-medium text-sm text-gray-500" }, " メッセージと共に送信する画像（任意） ", -1)
const _hoisted_53 = { class: "w-full flex items-center overflow-x-scroll" }
const _hoisted_54 = /*#__PURE__*/_createVNode("path", { d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" }, null, -1)
const _hoisted_55 = { for: "image" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", null, "画像を追加", -1)
const _hoisted_57 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_58 = {
  key: 0,
  class: "p-4 flex flex-col items-center rounded-md border-2 border-gray-200"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("p", null, "送信予約を削除", -1)
const _hoisted_60 = {
  key: 0,
  class: "w-full flex items-center"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("p", null, "繰り返し終了日", -1)
const _hoisted_62 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("p", null, "送信予約 / 繰り返し設定を追加", -1)
const _hoisted_64 = {
  key: 0,
  class: "mr-6 text-gray-500 font-medium text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.modalTitle), 1)
    ]),
    body: _withCtx(() => [
      (_ctx.toType == 'students')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.selectedStudents.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedStudents, (student) => {
                    return (_openBlock(), _createBlock("div", {
                      key: student.ref.id,
                      class: "p-1 pl-2 mb-2 mr-3 flex items-center rounded-md border border-secondary-500"
                    }, [
                      _createVNode("p", _hoisted_4, _toDisplayString(student.data.name), 1),
                      _createVNode("div", {
                        class: "p-1 ml-1 text-gray-500 cursor-pointer",
                        onClick: ($event: any) => (_ctx.removeStudent(student.ref.id))
                      }, [
                        _createVNode(_component_m_icon, { type: "close" })
                      ], 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.toType === 'students' && _ctx.selectedStudents.length === 0)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_m_icon, {
                    type: "warning",
                    size: "6",
                    class: "mr-2"
                  }),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, [
                _createVNode("input", {
                  id: "group",
                  type: "radio",
                  name: "group",
                  checked: _ctx.toType == 'group',
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toType = 'group'))
                }, null, 40, ["checked"]),
                _hoisted_10
              ]),
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("input", {
                      id: "school",
                      type: "radio",
                      name: "school",
                      checked: _ctx.toType == 'school',
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toType = 'school'))
                    }, null, 40, ["checked"]),
                    _hoisted_12
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_13, [
                    _createVNode("input", {
                      id: "classroom",
                      type: "radio",
                      name: "classroom",
                      checked: _ctx.toType == 'classroom',
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toType = 'classroom'))
                    }, null, 40, ["checked"]),
                    _hoisted_14
                  ]))
            ])
          ])),
      (_ctx.toType == 'group')
        ? (_openBlock(), _createBlock("div", _hoisted_15, [
            _createVNode(_component_m_select_box, {
              key: "ref.id",
              label: "対象グループ",
              name: "group",
              placeholder: "全て",
              options: _ctx.groups,
              value: _ctx.selectedGroupId,
              "value-key": "ref.id",
              "text-key": "data.title",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedGroupId = $event))
            }, null, 8, ["options", "value"]),
            _hoisted_16
          ]))
        : (_ctx.toType == 'school')
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode(_component_m_select_box, {
                key: "ref.id",
                label: "スクールを選択(複数可)",
                name: "school",
                placeholder: "選択なし",
                options: _ctx.filteredSchools,
                value: _ctx.selectSchoolId,
                "value-key": "ref.id",
                "text-key": "data.name",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectSchoolId = $event)),
                class: "mb-2"
              }, null, 8, ["options", "value"]),
              _createVNode("div", _hoisted_18, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.schoolSearchKeyword = $event)),
                  type: "text",
                  name: "searchSchool",
                  placeholder: "名前かIDでスクールを検索...",
                  onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.searchSchools && _ctx.searchSchools(...args))),
                  class: "flex-grow bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                }, null, 544), [
                  [_vModelText, _ctx.schoolSearchKeyword]
                ])
              ]),
              (_ctx.searchedSchools.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchedSchools, (school, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: school.ref.id,
                        class: ["flex items-center py-1 border-gray-200", { 'border-b': i < _ctx.searchedSchools.length - 1 }]
                      }, [
                        (_ctx.selectedSchools.includes(school))
                          ? (_openBlock(), _createBlock("div", _hoisted_20, [
                              _createVNode(_component_m_icon, {
                                type: "check-circle",
                                size: "6"
                              })
                            ]))
                          : (_openBlock(), _createBlock(_component_m_button, {
                              key: 1,
                              text: "",
                              onClick: ($event: any) => (_ctx.addSchool(school.ref.id)),
                              class: "w-16 text-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 2
                            }, 1032, ["onClick"])),
                        _createVNode("div", _hoisted_22, [
                          _createVNode("p", _hoisted_23, _toDisplayString(school.data.name), 1),
                          _createVNode("p", _hoisted_24, _toDisplayString(school.data.id), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                (_ctx.selectedSchools.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode("div", _hoisted_27, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedSchools, (selectedSchool) => {
                          return (_openBlock(), _createBlock("div", {
                            key: selectedSchool.ref.id,
                            class: "p-1 pl-2 mb-2 mr-3 flex items-center rounded-md border border-secondary-500"
                          }, [
                            _createVNode("p", _hoisted_28, _toDisplayString(selectedSchool.data.name), 1),
                            _createVNode("div", {
                              class: "p-1 ml-1 text-gray-500 cursor-pointer",
                              onClick: ($event: any) => (_ctx.removeSchool(selectedSchool.ref.id))
                            }, [
                              _createVNode(_component_m_icon, { type: "close" })
                            ], 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_29, [
                  _createVNode(_component_m_button, {
                    onClick: _ctx.selectAllSchools,
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_m_button, {
                    onClick: _ctx.removeAllSchools,
                    color: "red-400",
                    "hover-color": "red-500",
                    outline: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
          : (_ctx.toType == 'classroom')
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode(_component_m_select_box, {
                  key: "ref.id",
                  label: "教室を選択(複数可)",
                  name: "classroom",
                  placeholder: "選択なし",
                  options: _ctx.classrooms,
                  value: _ctx.selectClassroomId,
                  "value-key": "ref.id",
                  "text-key": "data.name",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectClassroomId = $event)),
                  class: "mb-2"
                }, null, 8, ["options", "value"]),
                _createVNode("div", _hoisted_33, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.classroomSearchKeyword = $event)),
                    type: "text",
                    name: "searchClassroom",
                    placeholder: "名前かIDで教室を検索...",
                    onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.searchClassrooms && _ctx.searchClassrooms(...args))),
                    class: "flex-grow bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 544), [
                    [_vModelText, _ctx.classroomSearchKeyword]
                  ])
                ]),
                (_ctx.searchedClassrooms.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_34, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchedClassrooms, (classroom, i) => {
                        return (_openBlock(), _createBlock("div", {
                          key: classroom.ref.id,
                          class: ["flex items-center py-1 border-gray-200", { 'border-b': i < _ctx.searchedClassrooms.length - 1 }]
                        }, [
                          (_ctx.selectedClassrooms.includes(classroom))
                            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                _createVNode(_component_m_icon, {
                                  type: "check-circle",
                                  size: "6"
                                })
                              ]))
                            : (_openBlock(), _createBlock(_component_m_button, {
                                key: 1,
                                text: "",
                                onClick: ($event: any) => (_ctx.addClassroom(classroom.ref.id)),
                                class: "w-16 text-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          _createVNode("div", _hoisted_37, [
                            _createVNode("p", _hoisted_38, _toDisplayString(classroom.data.name), 1),
                            _createVNode("p", _hoisted_39, _toDisplayString(classroom.data.id), 1)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  (_ctx.selectedClassrooms.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode("div", _hoisted_42, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedClassrooms, (selectedClassroom) => {
                            return (_openBlock(), _createBlock("div", {
                              key: selectedClassroom.ref.id,
                              class: "p-1 pl-2 mb-2 mr-3 flex items-center rounded-md border border-secondary-500"
                            }, [
                              _createVNode("p", _hoisted_43, _toDisplayString(selectedClassroom.data.name), 1),
                              _createVNode("div", {
                                class: "p-1 ml-1 text-gray-500 cursor-pointer",
                                onClick: ($event: any) => (_ctx.removeClassroom(selectedClassroom.ref.id))
                              }, [
                                _createVNode(_component_m_icon, { type: "close" })
                              ], 8, ["onClick"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_44, [
                    _createVNode(_component_m_button, {
                      onClick: _ctx.selectAllClassrooms,
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_45
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_m_button, {
                      onClick: _ctx.removeAllClassrooms,
                      color: "red-400",
                      "hover-color": "red-500",
                      outline: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
      _createVNode("div", _hoisted_47, [
        _createVNode(_component_m_text_area, {
          label: "メッセージ内容  ※最大4500文字",
          name: "message",
          placeholder: "メッセージを入力",
          value: _ctx.message,
          onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.message = $event))
        }, null, 8, ["value"]),
        _createVNode("div", _hoisted_48, [
          _createTextVNode(" 文字数: " + _toDisplayString(_ctx.message.length) + " ", 1),
          (_ctx.message.length > 4500)
            ? (_openBlock(), _createBlock("span", _hoisted_49, " ※ 最大文字数を超えています "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_50, [
        _createVNode("div", _hoisted_51, [
          _hoisted_52,
          _createVNode("div", _hoisted_53, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileUrls, (url, i) => {
              return (_openBlock(), _createBlock("div", {
                key: url,
                class: "relative w-20 h-20 mr-2"
              }, [
                _createVNode("img", {
                  src: url,
                  alt: "Upload Image",
                  class: "w-16 h-16 mx-2 my-2 object-cover rounded-md border-2 border-gray-200"
                }, null, 8, ["src"]),
                (_openBlock(), _createBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  fill: "currentColor",
                  class: "absolute right-0 top-0 w-5 h-5 text-gray-500 transition-colors duration-300 cursor-pointer hover:text-black",
                  onClick: ($event: any) => (_ctx.removeImage(i))
                }, [
                  _hoisted_54
                ], 8, ["onClick"]))
              ]))
            }), 128)),
            _createVNode("label", _hoisted_55, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                outline: "",
                "is-div": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, { type: "plus" }),
                  _hoisted_56
                ]),
                _: 1
              }),
              _createVNode("input", {
                id: "image",
                type: "file",
                accept: "image/*",
                name: "image",
                multiple: "",
                class: "hidden",
                onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.imageUpload && _ctx.imageUpload(...args)))
              }, null, 32)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_57, [
        (_ctx.isReservation)
          ? (_openBlock(), _createBlock("div", _hoisted_58, [
              _createVNode(_component_m_button, {
                color: "gray-500",
                text: "",
                class: "mb-6",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isReservation = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, {
                    type: "trash",
                    class: "mr-2"
                  }),
                  _hoisted_59
                ]),
                _: 1
              }),
              _createVNode(_component_m_text_field, {
                label: "送信予定日",
                name: "day",
                type: "date",
                placeholder: "2020/11/22",
                value: _ctx.reserveDay,
                class: "mb-6",
                onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.reserveDay = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_m_text_field, {
                label: "送信予定時間",
                name: "time",
                type: "time",
                placeholder: "18:00",
                value: _ctx.reserveTime,
                class: "mb-6",
                onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.reserveTime = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_m_select_box, {
                key: "id",
                label: "繰り返し設定",
                placeholder: "繰り返し頻度",
                name: "regular",
                options: _ctx.regularPatternOptions,
                value: _ctx.selectedRegularPattern,
                "value-key": "id",
                "text-key": "text",
                class: "mb-6",
                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedRegularPattern = $event))
              }, null, 8, ["options", "value"]),
              (_ctx.existDeletionTime && _ctx.selectedRegularPattern != 'none')
                ? (_openBlock(), _createBlock("div", _hoisted_60, [
                    _createVNode(_component_m_text_field, {
                      label: "繰り返し終了日",
                      name: "deletionDay",
                      type: "date",
                      placeholder: "2020/11/22",
                      value: _ctx.deletionDay,
                      class: "mb-6 flex-1",
                      onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.deletionDay = $event))
                    }, null, 8, ["value"]),
                    _createVNode(_component_m_button, {
                      color: "gray-500",
                      text: "",
                      size: "sm",
                      class: "ml-2 flex-0",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.existDeletionTime = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_m_icon, { type: "trash" })
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.selectedRegularPattern != 'none')
                  ? (_openBlock(), _createBlock(_component_m_button, {
                      key: 1,
                      text: "",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.existDeletionTime = true))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_m_icon, {
                          type: "plus",
                          class: "mr-2"
                        }),
                        _hoisted_61
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_62, [
              _createVNode(_component_m_button, {
                text: "",
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isReservation = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    class: "mr-2"
                  }),
                  _hoisted_63
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.validType)
        ? (_openBlock(), _createBlock("p", _hoisted_64, " 対象生徒: " + _toDisplayString(_ctx.filteredStudents.length) + "人 ", 1))
        : _createCommentVNode("", true),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.tapMainButton
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.mainButtonTitle), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}